import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HISTORY } from '@ng-web-apis/common';
import { RouteTranslateService } from '../route-translate/route-translate.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  previousUrls: string[] = ['/'];
  regex =
    /\?(signin|signup|profileemailconfirm|forgotpassword)=(true|false)|\??((&?contentType=(event|wonder|sharry))|(&?v=0\.\d+)|(&?beginsAt=\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z).+)|(&?endsAt=\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z).+)|(&?value=w+))/g;

  constructor(
    @Inject(HISTORY) private history: History,
    private router: Router,
    private routeTranslateService: RouteTranslateService,
  ) {}

  setPreviousUrl(previousRoute: string) {
    const parsedRoute = previousRoute.replace(this.regex, '');
    if (this.previousUrls[this.previousUrls.length - 1] !== parsedRoute) {
      this.previousUrls.push(parsedRoute);
    }
  }

  back() {
    this.history.back();
    this.pop();
  }

  pop() {
    this.previousUrls.pop();
  }

  getPreviousUrl(): string {
    return this.previousUrls[this.previousUrls.length - 1];
  }
}
